<template>
<div>
  <carousel
    :autoplay="true" v-if="accountsInfo"
    :responsive="{
      1200:{items:4,nav:false},
      600:{items:2,nav:true}
    }"
    :nav="false" :items="1" ref="owl">
    <div
      v-for="(info, key) in statistic"
      @click="selectAccount({
        ...info,
        accountNumber: info.account_number,
      })"
      :key="key" class="w-full cursor-pointer inline-block p-4"
    >
      <StatisticsCardLine
        :icon="'HomeIcon'"
        :statistic="info.statistic"
        :statistic-title="info.account_number"
        :chart-data="info.chartData"
        :hide-chart="hideChart"
        :name="info.name"
        class=""
        :class="{'bg-selected': (info.id === selected)}"
      ></StatisticsCardLine>
    </div>
  </carousel>
</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine'
import Carousel from 'vue-owl-carousel'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'BillsStatistics',
  components: {StatisticsCardLine, Carousel},
  props: {
    hideChart: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: -1
    }
  },
  data: () => ({
    selected: null
  }),
  watch: {
    value (val) {
      for (const i in this.statistic) {
        if (this.statistic[i].id === val) {
          this.selected = this.statistic[i].id
          this.$emit('get-selected-account', {
            ...this.statistic[i],
            accountNumber: this.statistic[i].account_number
          })
          break
        }
      }
    }
  },
  methods: {
    ...mapActions('utils', ['fetchAccounts']),
    selectAccount (payload) {
      this.selected = payload.id
      this.$emit('get-selected-account', payload)
    }
  },
  computed: {
    ...mapGetters('utils', ['accountsInfo', 'getTpId']),
    statistic () {
      const statistics = []

      let info = {}
      for (const key in this.accountsInfo) {
        info = this.accountsInfo[key]
        const chartData = []
        for (const i in info.history) {
          chartData.push(info.history[i].balance)
        }
        statistics.push({
          id: info.id,
          account_number: info.account_number,
          statistic: `${info.balance.split('.')[0]} ${info.currency_code}`,
          statisticTitle: info.account_number,
          name: info.name,
          currency_code: info.currency_code,
          chartData: [
            {
              name: 'balance',
              data: chartData
            }
          ]
        })
      }

      return statistics
    }
  },
  mounted () {
    const timer = window.setInterval(() => {
      if (this.getTpId && this.statistic.length === 0) {
        this.fetchAccounts().then(() => {
          this.selected = this.statistic[0].id
          this.$emit('get-selected-account', {
            ...this.statistic[0],
            accountNumber: this.statistic[0].account_number
          })
        })
      } else {
        this.$emit('get-selected-account', {
          ...this.statistic[0],
          accountNumber: this.statistic[0].account_number
        })
      }
      window.clearInterval(timer)
    }, 1000)
  },
  beforeDestroy () {
    this.selected = null
  }
}
</script>

<style scoped>
  .bg-selected {
    background: linear-gradient(0deg, rgba(var(--vs-primary), .2), rgba(var(--vs-primary), .01)) !important;
  }
</style>
